import { Flex } from "antd";
import { FC, useState } from "react";
import { Coords, Point } from "tm-shared/types";

import { useAppDispatch } from "@/hooks/redux";
import { useMakeCommand } from "@/hooks/requestQueue/useRequestQueue";
import { BaseModal } from "@/shared/ui/BaseModal";
import { SecondaryText } from "@/shared/ui/Typography";
import { enqueueRequestQueueItem } from "@/store/slices/offline";
import { setTaskCompleted } from "@/store/slices/work";

import { StyledWarningIcon } from "./Styled";

export interface StartVisitModalWarningPayload {
    taskId: string;
    point: Point;
    dist: number;
    coords: Coords;
}

interface StartVisitModalWarningProps {
    onCloseModal: () => void;
    payload: StartVisitModalWarningPayload;
}

export const StartVisitModalWarning: FC<StartVisitModalWarningProps> = ({
    payload,
    onCloseModal,
}) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    const { point, coords, taskId } = payload;
    const { makeTaskCompleteCommands } = useMakeCommand();

    const handleConfirm = async () => {
        setLoading(true);

        const taskCompleteCommands = await makeTaskCompleteCommands({
            params: {
                taskId,
                hasPhoto: false,
                payload: { coords },
            },
            coords,
        });

        dispatch(
            enqueueRequestQueueItem({
                id: taskId,
                metadata: { pointId: point.id, taskId },
                commands: taskCompleteCommands,
            }),
        );

        dispatch(
            setTaskCompleted({
                targetId: point.id,
                taskId,
            }),
        );

        onCloseModal();
    };

    return (
        <BaseModal
            open
            onClose={onCloseModal}
            onConfirm={handleConfirm}
            title="Увага!"
            description="Ви розпочинаєте візит поза зоною торгової точки, якщо ви продовжите, це буде зафіксовано у звіті про виконання задач."
            confirmText="Продовжити"
            cancelText="Скасувати"
            icon={<StyledWarningIcon>!</StyledWarningIcon>}
            confirmLoading={loading}
            mask={{ closable: !loading }}
        >
            <Flex vertical>
                <SecondaryText>
                    Відстань до торгової точки — {payload.dist} км.
                </SecondaryText>

                <SecondaryText>Максимально допустима — 500 м.</SecondaryText>
            </Flex>
        </BaseModal>
    );
};
